import { VueQueryPlugin, QueryClient, QueryCache } from '@tanstack/vue-query'

export default defineNuxtPlugin((nuxtApp) => {
  const queryClient = new QueryClient({
    // Runs once per failed fetch, not once per component using the query.
    queryCache: new QueryCache({
      onError: (_error, query) => {
        const errorToast = query.meta?.errorToast
        if (!errorToast) return
        nuxtApp.runWithContext(() =>
          useToastNotifications().addToast({
            type: 'error',
            ...errorToast,
            life: 5000,
          }),
        )
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 2 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
    },
  })

  nuxtApp.vueApp.use(VueQueryPlugin, { queryClient })
})
